export const IS_SSR = !!navigator && navigator.userAgent === 'ReactSnap';
